import NeuroPromptsDashboardTable from 'components/tables/NeuroPromptsDashboardTable';
import React from 'react';

const NeuroSkillsDashboard = () => {
  return (
    <>
      <h3>NeuroPrompt Administration</h3>
      <p className="text-body-tertiary lh-sm mb-4">
        General NeuroPrompt Administration Center.
      </p>
      <NeuroPromptsDashboardTable />
    </>
  );
};

export default NeuroSkillsDashboard;